import getAccessibleProducts from './getAccessibleProducts';

const transformConfigIntoGlobalNavSettings = productConfig => {
  const productsArr = getAccessibleProducts(productConfig).map(arr => ({
    key: arr[0],
    value: arr[1]
  })).map(el => {
    const arr = [];
    Object.entries(el.value).map(([key, value]) => ({
      key,
      value
    })).forEach(x => {
      if (typeof x.value !== 'object') {
        arr.push({
          key: `${el.key}.${x.key}`,
          value: `${x.value}`
        });
      }
    });
    return arr;
  });
  const settings = Array.prototype.concat(...productsArr);
  return settings;
};

export default transformConfigIntoGlobalNavSettings;
//# sourceMappingURL=transformConfigIntoGlobalNavSettings.js.map